import axios from 'axios'

import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'

const MESSAGES_ENDPOINT = `${API_BASE}messages/`

export default class MessageAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new MessageAPI(cls)
  }

  create(message) {
    const data = this.cls.toAPI(message)
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = axios
      .post(MESSAGES_ENDPOINT, data, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'Create Message API error' }))
    return promise
  }

  list({ pagination, filters }) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({ key: 'page' }),
      pageSize: ApiFilter.create({ key: 'page_size' }),

      // Sorting
      ordering: ApiFilter.create({ key: 'ordering' }),

      //
      request: ApiFilter.create({ key: 'request' }),
      //
      stipend_request: ApiFilter.create({ key: 'stipend_request' }),

      message_type: ApiFilter.create({ key: 'message_type' }),
    }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, { ...pagination, ...filters }),
    }

    const promise = axios
      .get(`${MESSAGES_ENDPOINT}`, options)
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'List Messages API error',
          rethrowErrors: true,
        }),
      )
    return promise
  }

  retrieve(messageId) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = axios
      .get(`${MESSAGES_ENDPOINT}${messageId}/`, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'Retrieve Message API error' }))
    return promise
  }

  /**
   * Indicate that a notification has been read by the user.
   *
   * @param {object} data
   *
   * @returns {Promise}
   */
  async markRead(message) {
    const url = `${MESSAGES_ENDPOINT}${message.id}/mark-read/`
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    return axios
      .post(url, null, options)
      .then(response => response.data)
      .catch(apiErrorHandler({ apiName: 'Mark Message as read error' }))
  }

  async delete(id) {
    const url = `${MESSAGES_ENDPOINT}${id}/delete/`
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    return axios
      .post(url, null, options)
      .then(response => response.data)
      .catch(apiErrorHandler({ apiName: 'Delete message API error' }))
  }
}
